module.exports = __webpack_public_path__ + "img/noData.04c82efc.png";